import {FormGroup} from "@angular/forms";

export interface JSONFormGroup {
  form: FormGroup;
}

export function isJSONFormGroup(obj: any) {
  return obj && Object.prototype.hasOwnProperty.call(obj, "form") && obj["form"] && obj["form"] instanceof FormGroup;
}

export function getFormGroupFromJSONFormGroup(obj: JSONFormGroup) {
  return obj.form as FormGroup;
}
